<!--  -->
<template>
  <div>
    <el-table :data="tableData" border style="width: 100%">
      <el-table-column
        prop="batch_no"
        label="批次编号"
        width="260"
        align="center"
      />
      <el-table-column prop="msg" label="结果说明" width="400" align="center" />
      <el-table-column
        prop="result_text"
        label="结果"
        align="center"
        width="200"
      />
      <el-table-column
        prop="send_time_text"
        label="发送对象"
        align="center"
        width="400"
      >
        <template slot-scope="scope">
          <el-tag
            v-for="(item, index) in scope.row.target_text"
            :key="index"
            style="margin-right: 10px"
          >{{ item }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="send_time_text" label="发送时间" align="center" />
    </el-table>
    <pagination-right
      :current-page="query.page"
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import { strategyscriptPushRecordDetail } from '@/api/stwert.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: { PaginationRight },
  data() {
    return {
      tableData: [],
      query: {
        job_no: '',
        page: 1,
        page_size: 10
      },
      total: null
    }
  },
  created() {},
  mounted() {},
  methods: {
    send(job_no) {
      this.query.job_no = job_no
      this.list()
    },
    async list() {
      const data = await strategyscriptPushRecordDetail(this.query)
      console.log('data', data)
      this.tableData = data.data.list
      this.total = data.data.total
      console.log('data', data)
    },
    // 分页
    fetchPageSize(e) {
      this.query.page_size = e
      this.list()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.list()
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
</style>
